<template>
  <div>
    <TextInput
      label="First Name"
      placeholder="Elon"
      :modelValue="application.firstName"
      @update:modelValue="updateField('firstName', $event)"
    />
    <TextInput
      class="mt-4"
      label="Last Name"
      placeholder="Husk"
      :modelValue="application.lastName"
      @update:modelValue="updateField('lastName', $event)"
    />
    <PhoneInput
      class="mt-4"
      label="Phone Number"
      placeholder="+1 (281) 330 8004"
      :modelValue="application.phone"
      @update:modelValue="updateField('phone', $event)"
    />
    <TextInput
      class="mt-4"
      label="Email"
      placeholder="you@example.com"
      :modelValue="application.email"
      @update:modelValue="updateField('email', $event)"
    />
    <TextInput
      class="mt-4"
      label="RE License Number"
      :optional="true"
      placeholder="123456"
      :modelValue="application.reLicenseNumber"
      @update:modelValue="updateField('reLicenseNumber', $event)"
    />
    <FileInput
      label="Resume"
      :optional="true"
      limits="any Document"
      :modelValue="application.resume"
      accept=".pdf, .doc, .docx"
      @update:modelValue="updateField('resume', $event)"
    />
    <CheckboxInput
      class="mt-4"
      description="By submitting this form and applying for this job, you consent to receive text messages, phone calls, or emails at the number or email provided regarding this application for employment. Msg & data rates may apply. Msg frequency varies. Unsubscribe at any time by replying STOP or clicking the unsubscribe link (where available)."
      :modelValue="application.contactMethodsOptIn"
      :required="true"
      @update:modelValue="updateField('contactMethodsOptIn', $event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    record: {
      type: Object,
      required: true
    },
    modelValue: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      application: {
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        reLicenseNumber: '',
        resume: '',
        contactMethodsOptIn: false,
      }
    };
  },
  watch: {
    modelValue: {
      handler(val) {
        if (val) {
          this.application = { ...val };
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.emitUpdate();
  },
  methods: {
    updateField(field, value) {
      this.application[field] = value;
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit('update:modelValue', { ...this.application });
      this.$emit('form-valid', this.isFormValid());
    },
    isFormValid() {
      if (!this.application.firstName || this.application.firstName.trim() === '') return false;
      if (!this.application.lastName || this.application.lastName.trim() === '') return false;
      if (!this.application.phone || this.application.phone.trim() === '') return false;
      if (!this.application.email || this.application.email.trim() === '') return false;
      if (!this.application.contactMethodsOptIn) return false;
      
      return true;
    },
    validate() {
      return this.isFormValid();
    },
    validateForm() {
      return this.validate();
    }
  }
};
</script>
